// extracted by mini-css-extract-plugin
export default {"container":"App_container__4L7Vo","sidebar":"App_sidebar__Ppt1G","hamper":"App_hamper__Um1vq","home":"App_home__5V9aF","content":"App_content__naSmy","profile":"App_profile__WnXg-"};